import ReactMarkdown from "react-markdown";

import { markdownComponents } from "../lib/markdown";
import { GlassCard } from "./GlassCard";

interface MemoReaderProps {
  markdown: string;
}

export function MemoReader({ markdown }: MemoReaderProps) {
  return (
    <GlassCard className="memo-reader">
      <ReactMarkdown components={markdownComponents}>{markdown}</ReactMarkdown>
    </GlassCard>
  );
}
